import React from "react";
import {PrimaryCollapsibleSection} from "../../../../../elements/collapsableSection/primary/PrimaryCollapsibleSection";
import {CardField} from "./components/CardField";
import {ReturnedFinanceApplicationChatEventDTO, UserDTO} from "../../../../../../api/generated";
import {getDrivingLicenceTitle, getResidentialStatusTitle} from "../../../../../../utils/enumValueTitleUtil";

interface FinanceApplicationChatEventCardProps {
    user: UserDTO
    returnedFinanceApplicationChatEvent: ReturnedFinanceApplicationChatEventDTO
}

export const FinanceApplicationChatEventCard: React.FC<FinanceApplicationChatEventCardProps> = ({
                                                                                                    user,
                                                                                                    returnedFinanceApplicationChatEvent
                                                                                                }) => {
    return <PrimaryCollapsibleSection title={"Finance Application"}>
        <CardField
            title="Full Name"
            value={user.name}
        />
        <CardField
            title="Email"
            value={user.email}
        />
        <CardField
            title="Phone Number"
            value={user.phoneNumber}
        />
        <CardField
            title="Home Address"
            value={returnedFinanceApplicationChatEvent.current_home_address}
        />
        <CardField
            title="Time at Address"
            value={returnedFinanceApplicationChatEvent.number_of_months_spent_at_current_address}
            sign={' months(s)'}
        />
        {returnedFinanceApplicationChatEvent.previous_home_address && <CardField
            title="Previous Home Address"
            value={returnedFinanceApplicationChatEvent.previous_home_address}
        />}
        <CardField
            title="Residential Status"
            value={getResidentialStatusTitle(returnedFinanceApplicationChatEvent.residential_status)}
        />
        <CardField
            title="Employer"
            value={returnedFinanceApplicationChatEvent.current_employer_name}
        />
        <CardField
            title="Time with Employer"
            value={returnedFinanceApplicationChatEvent.number_of_months_spent_with_current_employer}
            sign={' month(s)'}
        />
        {returnedFinanceApplicationChatEvent.previous_employer_name && <CardField
            title="Previous Employer"
            value={returnedFinanceApplicationChatEvent.previous_employer_name}
        />}
        <CardField
            title="Driving License Status"
            value={getDrivingLicenceTitle(returnedFinanceApplicationChatEvent.driving_licence)}
        />
    </PrimaryCollapsibleSection>
}
